import React, { Component } from 'react'
import withRoot from '../../withRoot'
import { Login as Layout } from '../../layouts'
import { Box, ForgotPassword as Page } from '../../components/index'
import { t as i18n } from 'ttag'

class ForgotPasswordContainer extends Component {
  render() {
    return (
      <Layout>
        <Box
          headerTitle={i18n`Forgot your password?`}
          enableLinks={false}
          {...this.props}
        >
          <Page {...this.props} />
        </Box>
      </Layout>
    )
  }
}

export default withRoot(ForgotPasswordContainer)
